var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8477 1.375C14.6836 1.375 14.5195 1.42969 14.3555 1.53906L11.375 3.45312V1.8125C11.375 1.10156 10.7188 0.5 9.95312 0.5H1.39453C0.628906 0.5 0 1.10156 0 1.8125V9.71484C0 10.4258 0.628906 11 1.39453 11H9.95312C10.7188 11 11.375 10.4258 11.375 9.71484V8.07422L14.3555 9.98828C14.5195 10.0977 14.6836 10.125 14.8477 10.125C15.3125 10.125 15.7227 9.76953 15.7227 9.27734V2.25C15.75 1.73047 15.3125 1.375 14.8477 1.375ZM10.5 9.71484C10.5 9.93359 10.2266 10.125 9.95312 10.125H1.39453C1.12109 10.125 0.875 9.93359 0.875 9.71484V1.8125C0.875 1.59375 1.12109 1.375 1.39453 1.375H9.95312C10.2266 1.375 10.5 1.59375 10.5 1.8125V9.71484ZM14.875 9.27734L14.8203 9.25L11.375 7.03516V4.49219L14.875 2.25V9.27734Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.34cc260efad7d9eac1d5d84a79c6c879.svg";
export { ForwardRef as ReactComponent };